import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warehouse",
  "use": "icon-warehouse-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-warehouse\"><path d=\"M30.176 4.041a1 1 0 0 1-.707 1.225L28 5.66V28H5V11.823l-1.61.431a1 1 0 0 1-.518-1.932l26.08-6.988a1 1 0 0 1 1.224.707M26 6.196l-19 5.09V26h19zM24 20v4h-4v-4zm-11 0v4H9v-4zm6 0v4h-5v-4zm-6-5v4H9v-4zm11 0v4h-4v-4zm-5 0v4h-5v-4zm5-5v4h-4v-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol